import styled, { css } from 'styled-components'
import { Button } from '@sainsburys-tech/bolt'
import { colorToLunaToken, remCalculator, hexWithTransparency } from '../../../helpers/theming/utilities'

const Container = styled.div`
  margin-bottom: ${(props) => (props.noMargin ? 0 : remCalculator(props.theme.size.spacing.lg))};
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
`

const primaryCSS = (color, backgroundColor) => css`
  color: ${color};
  background-color: ${backgroundColor};
`

const secondaryCSS = (color) => css`
  color: ${color};
  border-color: ${color};
`

const M032Button = styled(Button)`
  /* TODO: remove forwardedAs and use onClick instead */
  text-decoration: none;
  ${(props) =>
    css`
      ${secondaryCSS(colorToLunaToken(props.backgroundColor, props.theme))};

      ${props.theme.channel === 'tu' &&
      css`
        border-radius: 0;
      `}

      &:hover,
      &:active {
        ${props.theme.channel === 'habitat'
          ? css`
              ${secondaryCSS(props.theme.color.monochrome.dark)};
              background-color: ${hexWithTransparency(props.theme.color.monochrome.dark, 0.06)};
            `
          : css`
              ${secondaryCSS(colorToLunaToken(props.backgroundColor, props.theme))};
            `}
      }
    `}

  ${(props) =>
    props.kind === 'primary' &&
    css`
      ${primaryCSS(props.theme.color.monochrome.white, colorToLunaToken(props.backgroundColor, props.theme))}

      &:hover,
        &:active {
        ${props.theme.channel === 'habitat'
          ? css`
              ${primaryCSS(props.theme.color.monochrome.lighter, props.theme.color.monochrome.dark)}
            `
          : css`
              ${primaryCSS(props.theme.color.monochrome.white, colorToLunaToken(props.backgroundColor, props.theme))}
            `}
      }
    `}
`

export { Container, M032Button }
